<template>
    <div>
        
        <NuxtLoadingIndicator color="#9fd3e0" />
        <NuxtPage />
    </div>
</template>

<script setup lang="ts">
const { locale } = useI18n();

useHead({
    htmlAttrs: {
        lang: () => locale.value ?? 'en',
    },
});
</script>
